import React, { Component } from "react";
import Link from '../../PageLayout/Link/Link';
import { Button } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroller';
import ApiService from '../../Services/ApiService';
import PropTypes from 'prop-types';
import ProjectCardDescription from './component/ProjectCardDescription';
import Spinner from '../../PageLayout/Spinner';
import projectSearchNoResultImg from "images/project_search_no_result.svg";

class ProjectSearchResult extends Component {
  static propTypes = {
    search: PropTypes.object.isRequired,
    searchCallback: PropTypes.any,
    forceReload: PropTypes.bool,
    showLoading: PropTypes.bool,
  }

  static defaultProps = {
    showLoading: false
  };

  constructor(props) {
    super(props);

    this.state = {
      searchResults: [],
      availableTags: [],
      isLoading: true,
      hasMore: true,
      page: 1
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.search) != JSON.stringify(prevProps.search)) {
      this.setState({searchResults: []})
      this.loadData();
    }
  }

  loadData = (page = 1) => {
    const body = { ...this.props.search, page };
    this.request = [
      ApiService.projectSearch(body),
      ApiService.getRef(),
    ];

    Promise.all(this.request).then(data => {
      if (this._isMounted) {
        let showMore = data[0].length === 0 || data[0].length < 20;
        let searchResults = this.state.searchResults;
        searchResults = searchResults.concat(data[0]);
        searchResults = searchResults.filter((item, index) => searchResults.findIndex(i => i.project.projectId === item.project.projectId ) === index);
        this.setState({
          searchResults,
          isLoading: false,
          availableTags: data[1].tagRefs,
          hasMore: !showMore
        });

        if (this.props.searchCallback) {
          this.props.searchCallback(data[0]);
        }
      }
    });
  }

  render() {
    let result = null;

    if (this.state.isLoading) {
      if (this.props.showLoading) {
        return <p><Spinner />{"\tSearching project..."}</p>;
      } else {
        return null;
      }
    }

    if (this.state.searchResults && this.state.searchResults.length > 0) {
      result = (

        <ul>
          <InfiniteScroll
            pageStart={1}
            loadMore={this.loadData}
            hasMore={this.state.hasMore}
            loader={<p><Spinner />{"\tSearching project..."}</p>}
            threshold={100}
          >
            {this.state.searchResults.map((prj) => (
              <li key={prj.project.projectId}>
                <ProjectCardDescription availableTags={this.state.availableTags} project={prj} />
              </li>
            ))}
          </InfiniteScroll>
        </ul>

      );
    } else {
      result = this.props.search.requesterStar
      ? (
        <div className='noResult'>
          <div className='noResultHelper'>
            <h4>{'No favourites found'}</h4>
            <h5><i className="icon-star-fg icon-star-bg active"></i> {'Mark any project by clicking on stars'} <i className="icon-star-fg icon-star-bg active"></i></h5>
          </div>
        </div>
      ) : (
        <div className='noResult'>
          <img className='noResultImage' src={projectSearchNoResultImg} alt="noresult" />
          <div className='noResultHelper'>
            <h4>{'No project found'}{this.props.search.searchText && (" for '" + this.props.search.searchText + "'")}{' with applied filters'}</h4>
            <h5>{'Try defining your search string or remove filters to widen the scope of your search or create your new project'}</h5>
          </div>
          <Link to={"/project/request/create"}>
            <Button><i className="icon-circle-plus" /> Request a new project</Button>
          </Link>
        </div>
      );

    }

    return (
      <div className={'projectSearchResult'}>
        { this.props.forceReload ? null : result}
      </div>
    );
  }
}

export default ProjectSearchResult;
